import React from 'react';
import LeftSideBar from '../../common/LeftSideBar';
import { useNavigate } from 'react-router';

export default function FavAndSavedSidebar({
  activeSection,
  setActiveSection,
  activeSubSection,
  setActiveSubSection,
}) {
  const navigate = useNavigate();
  const handleNavigation = (href) => {
    navigate(href);
  };
  return (
    <React.Fragment>
      {/* <LeftSideBar
        title={
          <>
            <span className="flex items-center gap-2">
              <span>Favorite</span>
            </span>
          </>
        }
        secondarySidebar={true}
        // openAccordActive={activeSection === 'contactInfo' ? true : false}
        openAccordActive={true}
        // accordOnClick={() => {
        //   setActiveSection('contactInfo');
        // }}
      />
      <LeftSideBar
        title={
          <>
            <span className="flex items-center gap-2">
              <span>Saved</span>
            </span>
          </>
        }
        secondarySidebar={true}
        // openAccordActive={activeSection === 'contactInfo' ? true : false}
        // accordOnClick={() => {
        //   setActiveSection('contactInfo');
        // }}
      /> */}
      <LeftSideBar
        title={
          <>
            <span className="flex items-center gap-2">
              {/* <BsCreditCard2Front className="w-5 h-5" /> */}
              <span>Favorite & Saved</span>
            </span>
          </>
        }
        menu={[
          {
            name: 'Favorite',
            href: '#',
            // icon: (
            //   <>
            //     <BsInfoCircle />
            //   </>
            // ),
            active:
              activeSection === 'fav_saved' && activeSubSection === 'favorite'
                ? true
                : false,
            onClick: (e) => {
              // handleNavigation('#');
              e.stopPropagation();
              setActiveSubSection('favorite');
            },
          },
          {
            name: 'Saved',
            href: '#',
            // icon: (
            //   <>
            //     <MdOutlineEditLocation />
            //   </>
            // ),
            active:
              activeSection === 'fav_saved' && activeSubSection === 'saved'
                ? true
                : false,
            onClick: (e) => {
              // handleNavigation('#');
              e.stopPropagation();
              setActiveSubSection('saved');
            },
          },
        ]}
        secondarySidebar={true}
        openAccordActive={activeSection === 'fav_saved' ? true : false}
        accordOnClick={() => {
          setActiveSection('fav_saved');
          setActiveSubSection('favorite');
        }}
      />
    </React.Fragment>
  );
}
